import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { DECK_ADMIN_URL } from "./deckAdminUrl";
import { SearchSubstructureFamiliesResponse, UpdateSubstructureFamilyBody } from "./types/substructureFamilies";

export const useDeckSubstructureFamiliesApi = () => {
  const crud = createAdminCrudApi<SearchSubstructureFamiliesResponse, never, UpdateSubstructureFamilyBody>(
    useApi(),
    DECK_ADMIN_URL,
    "substructure_families",
  );

  return {
    useDeckSubstructureFamilies: crud.useSearch,
    getDeckSubstructureFamilies: crud.search,
    updateDeckSubstructureFamily: crud.update,
    updateDeckSubstructureFamilyVisibility: crud.updateVisibility,
    updateDeckSubstructureFamilyOrder: crud.updateOrder,
  };
};

export default useDeckSubstructureFamiliesApi;
